<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Cotar Frete",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader,   },
  setup() {

  },
  data() {
    return {

      errosCotacao: null,
      cotaFrtResults: null,

      showModalCotarFrete: false,
      loadingCotarFrete: false,
      loadingCnpj: false,
      loadingCidOri: false,
      loadingCidDest: false,
      dtListPesqSegto: null,
      showModalVolume: false,
      cotaFrtVolume: {},
      cotaFrtVolumes: {},
      submittedVolume: false,
      seguimentoData: null,


      updating: true,
      errosValid: null,
      contratoData: {
        id: 0,
        status: 'AB'
      },


      idData: 0,
      submitted: false,

      title: "Cotar Frete",
      items: [
        {
          text: "Cotações",
          href: "/cotafrts/list",
        },
        {
          text: "Cotar Frete",
          active: true,
        },
      ],

    };
  },

  methods: {

    cotarFrete(){
      console.log('cotarFrete')
      this.showModalCotarFrete = true
      this.loadingCotarFrete = true
      this.errosCotacao = null

      api.get(`${getBaseUrl()}api/cotarfrtmanu`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data)
        console.log(res.data['SDT_WSRetorno']['Resultados'])
        // console.log(res.data[0]['SDT_WSRetorno'])

        if (res.data['SDT_WSRetorno']['Resultados']) {
          this.cotaFrtResults = res.data['SDT_WSRetorno']['Resultados']
          let menorValor = 999999
          let menorPrazo = 999999
          this.cotaFrtResults.forEach((value) => {
            if (value.WSOut_Frete_Val < menorValor){
              menorValor = value.WSOut_Frete_Val
            }
            if (value.WSOut_Prazo_Dias < menorPrazo){
              menorPrazo = value.WSOut_Prazo_Dias
            }

            value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val)

          })

          this.cotaFrtResults.forEach((value) => {
            if (value.WSOut_Frete_Val === menorValor){
              value['menorvalor'] = true
            }
            if (value.WSOut_Prazo_Dias === menorPrazo){
              value['menorprazo'] = true
            }
          })

        } else if (res.data['SDT_WSRetorno']['Messages']) {
          console.log('mensagens de erro')
          console.log(res.data['SDT_WSRetorno']['Messages'])
          this.errosCotacao = res.data['SDT_WSRetorno']['Messages']
        }
        this.loadingCotarFrete = false

      })

    },




    deletarVol(indexVol){
      console.log('deletarVol')
      console.log(indexVol)

      this.cotaFrtVolumes.splice(indexVol, 1)

    },


    addVolume(){
      console.log('addVolume')
      this.cotaFrtVolumes.push({
        'cotafrt_id': this.idData
      });



    },


    consultarCNPJ(){
      console.log('consultarCNPJ')
      const cnpjTratado = this.contratoData.cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingCnpj = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const dadosCnpj = res.data[0]
          this.contratoData.nome = dadosCnpj.nome

          this.loadingCnpj = false
        });
      }
    },

    informouCepOri(){
      console.log('informouCepOri')
      const cepTratado = this.contratoData.cepori.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length === 8){
        this.loadingCidOri = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const dataCep = res.data[0]
          this.contratoData.cidori = dataCep.localidade
          this.loadingCidOri = false
        });
      }
    },

    informouCepDest(){
      console.log('informouCepDest')
      const cepTratado = this.contratoData.cepdest.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length === 8){
        this.loadingCidDest = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const dataCep = res.data[0]
          this.contratoData.ciddest = dataCep.localidade
          this.loadingCidDest = false
        });
      }
    },

    pesqSegto(evt) {
      console.log('pesqSegto')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/segtopesq`, {
          params: { q: query, c: 'FO' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqSegto = res.data
        });
      }

    },


    escolheuSegto(){
      console.log('escolheuSegto')

    },


    editar(dataReg) {
      console.log('editar')
      this.cotaFrtVolume = dataReg
      this.showModalVolume = true
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          console.log('deletouReg_pai dataid:')
          console.log(dataID)

          this.loadingList = true
          api.delete(`${getBaseUrl()}api/cotafrtvol`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },

    novoVolume(){
      console.log('novoVolume')
      this.cotaFrtVolume = {}

      this.submittedVolume = false
      this.showModalVolume = true

      this.cotaFrtVolumes.push({
        'cotafrt_id': this.idData
      });


    },



    deletarEquipe(dataID){
      console.log('deletarEquipe')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projequip`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },



    confVolume(){
      console.log('confVolume')
      console.log(this.cotaFrtVolumes)
      this.submittedVolume = true

      let todosVolValids = true

      this.cotaFrtVolumes.forEach((value) => {
        if (!value.largura > 0 || !value.altura > 0 || !value.comprim > 0 || !value.quant > 0) {
          todosVolValids = false
        }
      })

      if (todosVolValids) {

        console.log('formSubmit_volume_validado')
        this.showModalVolume = false
        this.cotaFrtVolume.cotafrt_id = this.idData

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/cotafrtvols`, {
          cotafrtvolsData: this.cotaFrtVolumes,
          idcotafrt: this.idData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })

      }
    },



    copiarCotacao(){
      console.log('copiarCotacao')
      this.updating = false
      // this.updating = true
      // api.post(`${getBaseUrl()}api/projcopy`, {
      //   'iddata': this.idData
      // }).then((res) => {
      //   console.log('then axios copiar')
      //   console.log(res.data[0].id)
      //   //this.orctoData = res.data
      //
      //   this.idData = res.data[0].id
      //   this.$router.replace({ path: `/cotafrt/editar/${this.idData}` })
      //   this.carregarDados()
      //
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "success",
      //     title: "Registro copiado com sucesso!",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // })

    },


    cancelarCota(){
      console.log('cancelarCota')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          this.updating = false

          api.post(`${getBaseUrl()}api/cotafrtcanc`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)

            this.contratoData.status = 'CA'

            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Cotação cancelada com sucesso",
              showConfirmButton: false,
              timer: 1500
            })

          })


        }
      })

    },



    carregarDados(){

      this.updating = true

      api.get(`${getBaseUrl()}api/cotafrt`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios cotafrt')
        console.log(res.data)
        this.contratoData = res.data[0]
        this.cotaFrtVolumes = res.data[1]
        this.seguimentoData = res.data[2]

        if (this.seguimentoData && this.seguimentoData.id){
          this.dtListPesqSegto = [
            {
              'codigo': this.seguimentoData.codigo,
              'nome': this.seguimentoData.nome,
            }
          ]
        }

        this.idData = this.contratoData.id
        this.title = `Cotar Frete (${this.contratoData.id}) ${this.contratoData.cidori} - ${this.contratoData.ciddest}`

        this.updating = false
      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;

      if (this.contratoData.segto && this.contratoData.cepori && this.contratoData.cepdest && this.contratoData.cidori && this.contratoData.ciddest) {


        this.updating = true
        this.errosValid = []

        api.post(`${getBaseUrl()}api/cotafrt`, {
          cotafrtData: this.contratoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            this.idData = res.data[0].id
            this.contratoData = res.data[0]
            this.$router.replace('/cotafrt/editar/' + this.idData)
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },



    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){

      this.carregarDados()

    }else{

      this.title = `Criando Novo Contrato`
      this.updating = false
    }


  },

  watch: {
    'contratoData.valorbrt': {
      handler() {
        this.calculaTotal()
      }
    },
    'contratoData.desconto': {
      handler() {
        this.calculaTotal()
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="contratoData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-success" class="mx-2" @click="formSubmit" :disabled="contratoData.status !== 'AB'" >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>


              <b-button :disabled="true" variant="outline-info" class="mx-2" @click="copiarCotacao">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Copiar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="cancelarCota" :disabled="contratoData.id === 0 || contratoData.status !== 'AB'">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>


              <b-button variant="success" class="mx-2" @click="cotarFrete" v-if="contratoData.id > '0'
                                                                                  && contratoData.cepdest !== ''
                                                                                  && contratoData.cnpj !== ''
                                                                                  && contratoData.peso > 0
                                                                                  && contratoData.valornf > 0
                                                                                  && contratoData.dimens > 0 " >
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar Frete
              </b-button>


              <b-button variant="warning" class="mx-2" @click="novoVolume" v-if="contratoData && contratoData.status ==='AB' && contratoData.id > 0">
                <i class="bx bx-box font-size-16 align-middle me-2"></i>
                Volumes da Cotação
              </b-button>


<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="aprovaProj">-->
<!--                <i class="bx bx-check-double font-size-16 align-middle me-2" ></i>-->
<!--                Aprovação-->
<!--              </b-button>-->


            </div>
          </div>
        </div>
      </div>


      <form class="needs-validation" @submit.prevent="formSubmit">
        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-4
                    class="text-dark"
                    href="javascript: void(0);"
                >Dados Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
              <b-card-body>



                <div class="row mb-2">


                  <div class="col-md-6">
                    <label for="descricao">Descrição</label>
                    <div class="position-relative">
                      <input
                          id="descricao"
                          type="text"
                          v-model="contratoData.descricao"
                          class="form-control"
                          placeholder="Descrição"/>
                    </div>
                  </div>


                  <div class="col-md-3">
                    <label for="codigo">Código</label>
                    <div class="position-relative">
                      <input
                          id="codigo"
                          type="text"
                          v-model="contratoData.codigo"
                          class="form-control"
                          placeholder="Código"/>
                    </div>
                  </div>


                  <div class="col-md-3">
                    <label for="pessoa">Cliente / Fornecedor</label>
                    <div class="position-relative">
                      <input
                          id="pessoa"
                          type="text"
                          v-model="contratoData.pessoa"
                          class="form-control"
                          placeholder="Cliente / Fornecedor"/>
                    </div>
                  </div>

                </div>

                <div class="row mb-2">


                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="servico">Serviço</label>
                      <select
                          id="servico"
                          v-model="contratoData.servico"
                          class="form-control">
                        <option value="AL">Aluguel</option>
                        <option value="MN">Manutenção</option>
                        <option value="OU">Outros</option>
                      </select>
                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="tipo">Tipo</label>
                      <select
                          id="tipo"
                          v-model="contratoData.tipo"
                          class="form-control">
                        <option value="CO">Contrato</option>
                        <option value="AD">Aditivo</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="situacao">Situação</label>
                      <select
                          id="situacao"
                          v-model="contratoData.situacao"
                          class="form-control">
                        <option value="EL">Elaboração</option>
                        <option value="PD">Pendente Assinatura</option>
                        <option value="AS">Assinado</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="statuscont">Status</label>
                      <select
                          id="statuscont"
                          v-model="contratoData.status"
                          class="form-control">
                        <option value="VG">Vigente</option>
                        <option value="CA">Cancelado</option>
                        <option value="FZ">Finalizado</option>
                      </select>
                    </div>
                  </div>

                </div>


                <div class="row mb-2">

                  <div class="col-md-3">
                      <div class="mb-3">
                        <label for="dtinicio">Data de Início</label>
                        <input
                            id="dtinicio"
                            v-model="contratoData.dtinicio"
                            type="date"
                            class="form-control"
                            placeholder="Data de Início"/>
                      </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                        <label for="dttermino">Data de Término</label>
                        <input
                            id="dttermino"
                            v-model="contratoData.dttermino"
                            type="date"
                            class="form-control"
                            placeholder="Data de Término"/>
                      </div>
                  </div>



                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="valor">Valor</label>
                      <input
                          id="valor"
                          v-model="contratoData.valor"
                          type="number"
                          class="form-control"
                          placeholder="Valor"/>
                    </div>
                  </div>

                </div>


              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-3
                    class="text-dark"
                    href="javascript: void(0);"
                >Informações sobre faturamento</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
              <b-card-body>



                <div class="row mb-2">


                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="geraconta">Gerar Conta</label>
                      <select
                          id="geraconta"
                          v-model="contratoData.geraconta"
                          class="form-control">
                        <option value="RC">Receber</option>
                        <option value="PG">Pagar</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="diavencto">Dia Vencimento</label>
                      <input
                          id="diavencto"
                          v-model="contratoData.diavencto"
                          type="number"

                          class="form-control"
                          placeholder="Dia Vencimento"/>
                    </div>
                  </div>



                  <div class="col-md-8">
                    <label for="envfat">E-mail Envio de Fatura</label>
                    <div class="position-relative">
                      <input
                          id="envfat"
                          type="text"
                          v-model="contratoData.envfat"
                          class="form-control"
                          placeholder="E-mail Envio de Fatura"/>
                    </div>
                  </div>


                </div>

              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-1
                    class="text-dark"
                    href="javascript: void(0);"
                >Informações adicionais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
              <b-card-body>



                <div class="row mb-3">

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="transp">Transportadora</label>
                      <select
                          id="transp"
                          v-model="contratoData.transp"
                          class="form-control">
                        <option value="01">Transportadora Testes 001</option>
                        <option value="02">Transportadora Testes 002</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="transp">SLA</label>
                      <select
                          id="transp"
                          v-model="contratoData.transp"
                          class="form-control">
                        <option value="IM">Imediato</option>
                        <option value="OU">Outros</option>

                      </select>
                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="dtreaj">Data de Reajuste</label>
                      <input
                          id="dtreaj"
                          v-model="contratoData.dtreaj"
                          type="date"
                          class="form-control"
                          placeholder="Data de Reajuste"/>
                    </div>
                  </div>



                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="percreaj">Percentual Reajuste</label>
                      <input
                          id="percreaj"
                          v-model="contratoData.percreaj"
                          type="number"
                          class="form-control"
                          placeholder="Percentual Reajuste"/>
                    </div>
                  </div>



                </div>

                <div class="row">

                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="obslancto">Observações</label>
                      <textarea
                          id="obslancto"
                          v-model="contratoData.obs"
                          type="text"
                          class="form-control"
                          rows="2"
                          placeholder="Observações"/>
                    </div>
                  </div>


                </div>


              </b-card-body>

            </b-collapse>
          </div>
        </div>









      </form>

    </div>











  </Layout>
</template>
